import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class NotificationTemplateService {
  index(payload = {}) {
    let filters = {};
    if (payload.options) {
      filters = { ...filters, ...payload.options };
    }
    if (payload.search) {
      filters.search = payload.search;
    }
    if (payload.organization_id !== undefined) {
      filters.organization_id = payload.organization_id;
    }
    if (payload.channel) {
      filters.channel = payload.channel;
    }

    return axios.get(API_URL + "notification-templates", {
      params: filters,
      headers: authHeader(),
    });
  }

  placeholders() {
    return axios.get(API_URL + "notification-templates/placeholders", {
      headers: authHeader(),
    });
  }

  show(id) {
    return axios.get(API_URL + "notification-templates/" + id, {
      headers: authHeader(),
    });
  }

  store(item) {
    return axios.post(API_URL + "notification-templates", item, {
      headers: authHeader(),
    });
  }

  update(item) {
    return axios.put(API_URL + "notification-templates/" + item.id, item, {
      headers: authHeader(),
    });
  }

  delete(item) {
    return axios.delete(API_URL + "notification-templates/" + item.id, {
      headers: authHeader(),
    });
  }
}

export default new NotificationTemplateService();
